import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class InitialEstimateWithIcon extends Field {
  static subqueriesForModel() {
    return { initialEstimate: ['text'] };
  }

  get title() {
    return 'Initial estimate with icon';
  }

  exampleContents(): FieldContentsData {
    return {
      icon: { name: 'fa-solid fa-italic' },
      text: '5d',
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.initialEstimate?.text) {
      return {
        icon: { name: 'fa-solid fa-italic' },
        text: record.initialEstimate.text,
      };
    }

    return {};
  }
}
